<template>
  <div class="panel">
    <span class="mx-4">{{ $t("message.common.from") }}</span>
    <v-combobox
      :items="startHoursRange"
      v-model="from"
      :rules="timeRules"
      @input="emitHours($event, 'from')"
      class="select"
    >
      {{ hours[0] }}
    </v-combobox>
    <span class="mx-4">{{ $t("message.common.to") }}</span>
    <v-combobox
      :items="endHoursRange"
      v-model="to"
      :rules="timeRules"
      @input="emitHours($event, 'to')"
      class="select"
    >
      {{ hours[1] }}
    </v-combobox>

    <v-btn
      icon
      v-if="hasButton"
      absolute
      class="close-button"
      @click="$emit('remove')"
    >
      <v-icon>close</v-icon>
    </v-btn>
  </div>
</template>

<script>
import { regex } from "@/config/regex";
import moment from "moment";

export default {
  name: "ItemHoursPanel",
  props: {
    hasButton: {
      type: Boolean,
      default: false
    },
    hours: {
      type: Array,
      default: () => ["", ""]
    },
    hoursRange: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      hasError: false,
      from: this.hours[0],
      to: this.hours[1],
      timeRules: [
        v => {
          if (!v) {
            this.hasError = true;
            return "Pole jest wymagane";
          }
          this.hasError = false;
          return true;
        },
        v => {
          const match = v ? v.match(regex.timeFormat) : null;

          if (!(match && !!match[0])) {
            this.hasError = true;
            return "Podaj właściwy format czasu 'HH:MM'";
          }
          this.hasError = false;
          return true;
        }
      ]
    };
  },
  computed: {
    startHoursRange() {
      return [
        moment({
          hour: 0
        }).format("HH:mm"),
        ...this.hoursRange
      ];
    },
    endHoursRange() {
      return [
        ...this.hoursRange,
        moment({
          hour: 0
        }).format("kk:mm")
      ];
    }
  },
  methods: {
    emitHours(value, type) {
      if (type === "from") {
        this.from = value;
      } else {
        this.to = value;
      }

      this.$emit("hours", {
        from: this.from,
        to: this.to
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.panel {
  display: flex;
  align-items: center;
  position: relative;
}

.panel:not(:first-child) {
  margin-top: 12px;
}

.select {
  max-width: 100px;
  padding-top: 0;
  margin-top: 0;
}

.close-button {
  right: -50px;
}
</style>
